module.exports = __webpack_public_path__ + "static/media/data-vis.db3f1054.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/data-vis.mov
// module id = 406
// module chunks = 0